import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { StatusBadge } from 'components/Erp/Display'

const labels = {
  synced: ['success', 'Синхронизирован'],
  pending: ['warning', 'Ожидает синхронизации'],
  never: ['warning', 'Шлюз ещё не получал'],
  no_user: ['danger', 'Нет учётной записи — не синхронизируется'],
}

export default function GuardSyncStatus({ sync }) {
  useInterfaceLanguage();
  if (!sync) return <StatusBadge tone="warning">{tr("Нет данных")}</StatusBadge>
  const [tone, label] = labels[sync.status] || ['warning', 'Нет подтверждения узла']
  const synced = sync.last_synced ? new Date(sync.last_synced).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : ''
  return <div>
    <StatusBadge tone={tone}>{tr(label)}</StatusBadge>
    {synced && <small style={{ display: 'block', marginTop: 4 }}>{tr("Подтверждено шлюзом: ")}{synced}</small>}
    {sync.status !== 'no_user' && !sync.can_login && <small style={{ display: 'block', marginTop: 4, color: 'var(--theme-danger, #c47b7b)' }}>{tr("Нет PIN — вход в шлюз невозможен")}</small>}
  </div>
}
